import React, { useState, useEffect } from 'react';
import { fetchData } from '../common/Api';
import TableRowsIcon from '@mui/icons-material/TableRows';
import CommonTable from '../common/CommonTable';
import AppsIcon from '@mui/icons-material/Apps';
import ItemList from '../common/ItemList';
import { projectColumns } from '../common/TableColumns';
import { useSpace } from '../common/SpaceContextProvider';
import { useHistory } from 'react-router-dom';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import CsvDownloadButton from '../common/CsvDownloadButton';
import InfoIcon from '@mui/icons-material/Info';


const ProjectsTab = ({ id }) => {

    const { setProjects } = useSpace();
    const history = useHistory();
    const [data, setData ] = useState([]);
    const [error, setError] = useState(null);
    const [showAsList, setShowAsList] = useState(true);

    const tooltip = (
        <Tooltip id="projects-tab-tooltip">
            Create projects either by manually adding them one by one manually 
            or by importing them from a CSV file. File should contain three 
            columns: project name, project description (optional), project deadline 
            (optional but recommended for better automatic assignment). The projects
            should be prioritized - drag and re-order the projects to maintain correct
            priority. You can use test data as an example - press <b>Upload example data</b>.
        </Tooltip>
        );    

    const getData = async () => {
        try {
            await fetchData(
            `/api/v1/spaces/${id}/projects`
            ).then(response => setData(response.data));
        } catch (error) {
            setError(error);
        }
    }

    useEffect(() => {
        const getData = async () => {
            try {
                await fetchData(
                `/api/v1/spaces/${id}/projects`
                ).then(response => setData(response.data));
            } catch (error) {
                setError(error);
            }
        }
        getData();
    }, [id]);

    useEffect(() => {
        setProjects(data);
    }, [data]);

    useEffect(()=> {
        if (error) {
            console.log(`Error loading projects :: ${error.message}`);
            if (error.status === 401){
                history.push('/login');
            }
            setError(null);
        }
    }, [error, history]);

    return (
        <>
        <div className='tab-container'>
            <div className='tab-container-main-panel'>
            { 
                showAsList ? 
                <ItemList 
                    data={data} 
                    cols={projectColumns}
                    baseUrl={`/api/v1/spaces/${id}/projects`} 
                    setData={getData}
                    fields={['name', 'description', 'deadline']}
                    disableClick={true}
                    testDataFname={'/projects.json'}
                /> : 
                <CommonTable data={data} cols={projectColumns}/> 
            }
            </div>
            <div className='switch-list-table-view-container'>

            <OverlayTrigger placement="bottom" overlay={tooltip}>
                <div className='icon-container'>
                    <InfoIcon className='switch-view'></InfoIcon>
                </div>
            </OverlayTrigger>

            <OverlayTrigger placement="bottom" overlay={ <Tooltip id="show-as-table">Table view</Tooltip>}>
            <div className='icon-container'>
                <TableRowsIcon 
                className={`switch-view ${showAsList ? 'selected' : null}`} 
                onClick={() => setShowAsList(true)}/>
            </div>
            </OverlayTrigger>
            
            <OverlayTrigger placement="bottom" overlay={ <Tooltip id="show-as-list">List view</Tooltip>}>
            <div className='icon-container'><AppsIcon 
                className={`switch-view ${!showAsList ? 'selected' : null}`} 
                onClick={() => setShowAsList(false)}/>
            </div>
            </OverlayTrigger>

            {data.length > 0 && <CsvDownloadButton data={data} filename='projects.csv'/>}

            </div>
        </div>
        </>
    )
}

export default ProjectsTab;